import { Docs, RecommendedProductItem } from '@/types/algonomy';

class AlgonomyProductDTO {
  private recommendedProductItem;

  constructor(recommendedProductItem: RecommendedProductItem) {
    this.recommendedProductItem = recommendedProductItem;
  }

  public get getRecommendedProduct(): Docs {
    return this.cleanObject({
      id: this.recommendedProductItem.id,
      linkId: this.recommendedProductItem.productURL,
      clickUrl: this.recommendedProductItem.clickTrackingURL,
      imageId: this.recommendedProductItem.imageURL,
      priceCents: this.recommendedProductItem.priceCents,
      name: this.recommendedProductItem.name,
      rating: this.recommendedProductItem.rating,
      numReviews: this.recommendedProductItem.numReviews,
      NewPriceMin: this.recommendedProductItem.attributes?.NewPriceMin
        ? this.recommendedProductItem.attributes.NewPriceMin[0]
        : undefined,
      NewPriceMax: this.recommendedProductItem.attributes?.NewPriceMax
        ? this.recommendedProductItem.attributes.NewPriceMax[0]
        : undefined,
      NewSalePriceMin: this.recommendedProductItem.attributes?.NewSalePriceMin
        ? this.recommendedProductItem.attributes.NewSalePriceMin[0]
        : undefined,
      NewSalePriceMax: this.recommendedProductItem.attributes?.NewSalePriceMax
        ? this.recommendedProductItem.attributes.NewSalePriceMax[0]
        : undefined,
      ProductConditionMax: this.recommendedProductItem.attributes?.ProductConditionMax
        ? this.recommendedProductItem.attributes.ProductConditionMax[0]
        : this.recommendedProductItem.attributes?.ProductCondition
        ? this.recommendedProductItem.attributes.ProductCondition[0]
        : undefined,
      ProductCondition: this.recommendedProductItem.attributes?.ProductCondition
        ? this.recommendedProductItem.attributes.ProductCondition
        : undefined,
      PricePerUnit: this.recommendedProductItem.attributes?.PricePerUnit
        ? this.recommendedProductItem.attributes.PricePerUnit[0]
        : undefined,
      PricePerUnitLabel: this.recommendedProductItem.attributes?.PricePerUnitLabel
        ? this.recommendedProductItem.attributes.PricePerUnitLabel[0]
        : undefined,
      New: this.recommendedProductItem.attributes?.New ? this.recommendedProductItem.attributes.New[0] === '1' : false,
      UsedAnyPriceMin: this.recommendedProductItem.attributes?.UsedAnyPriceMin
        ? this.recommendedProductItem.attributes.UsedAnyPriceMin[0]
        : undefined,
      salePriceCents: this.recommendedProductItem.salePriceCents || -1,
      effectivePriceCents: -1,
      score: -1,
      Purchasable: 'true',
      ShortDescription: this.recommendedProductItem.attributes?.Description2
        ? this.recommendedProductItem.attributes.Description2[0]
        : '',
      AddToCartButtonText: '',
    });
  }

  private cleanObject(obj: Docs): Docs {
    const cleanedObj = {} as Docs;
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== undefined) {
        cleanedObj[key] = obj[key];
      }
    });
    return cleanedObj;
  }
}

export default AlgonomyProductDTO;
